import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { Environment } from '../../../models/constants/constants';
import { IAppState } from '../../../models/reduxState';
import { articleOnClickHandler, setVsbUpsellAlertActivated, setIsQueryChanged, hideRequestCreationTab } from '../../app/appActions';
import {
  getSuggestionsSelector,
  isFeedbackCoachmarkShowingSelector,
  isDarkThemeSelector,
  isGetHelpSelector,
  isQueryChangedSelector,
  isTeamsSelector,
  isSurfaceAppSelector,
  isThirdPartySelector,
  showCompactQueryFormSelector,
  showSearchBarSelector,
  isFeedbackCoachmarkEnabledSelector,
} from '../../app/selectors/contactUsSelector';
import { deeplinkPathSelector, isGetHelpBtnHiddenSelector, isPrivacyAndSupportHiddenSelector, shouldProceedQueryForGetHelpSelector } from '../../app/selectors/selfHelpSelectors';
import { FormQuerySubmit } from '../presentationalComponents/FormQuerySubmit';
import { hideAutoSuggest, setAutoSuggestFocusedIndex, setAutoSuggestResult, setAutoSuggestResultV2, setOriginalQuery, showAutoSuggest } from '../reduxUpdater/actions/autoSuggestActions';
import { initializeModalityStateOnGetHelp } from '../reduxUpdater/actions/modalitySectionActions';
import { clearRelatedCorrelationIds } from '../reduxUpdater/actions/selfHelpAlchemyActions';
import { formSubmission, hideCoachmark, setContactSearchedQueryText, setIsAutoSuggestCardSearch, setIsAutoSuggestCardSearchV2 } from '../reduxUpdater/actions/sharedStateActions';
import { dispatchAlchemyFetch, dispatchFetchAutoSuggest, dispatchFetchAutoSuggestV2 } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { getContactUsStyles } from '../styles/contactUsStyles';

const mapDispatchToProps = {
  setContactSearchedQueryText,
  setAutoSuggestFocusedIndex,
  setOriginalQuery,
  formSubmission,
  dispatchFetchAutoSuggest,
  dispatchFetchAutoSuggestV2,
  dispatchAlchemyFetch,
  initializeModalityStateOnGetHelp,
  articleOnClickHandler,
  showAutoSuggest,
  hideAutoSuggest,
  setIsAutoSuggestCardSearch,
  setIsAutoSuggestCardSearchV2,
  clearRelatedCorrelationIds,
  setAutoSuggestResult,
  setAutoSuggestResultV2,
  setVsbUpsellAlertActivated,
  setIsQueryChanged,
  hideCoachmark,
  hideRequestCreationTab,
};

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    autoSuggestFocusedIndex: state.ContactState.AutoSuggestState.autoSuggestFocusedIndex,
    runningInSoc: state.GlobalState.environment === Environment.SOC,
    showCompactQueryForm: showCompactQueryFormSelector(state),
    isAlchemyQueryInProgress: state.ContactState.SelfHelpAlchemyState.isAlchemyQueryInProgress,
    contactSearchedQuery: state.ContactState.SharedState.contactSearchedQuery,
    autoSuggestResults: state.ContactState.AutoSuggestState.autoSuggestResults,
    autoSuggestResultsV2: state.ContactState.AutoSuggestState.autoSuggestResultsV2,
    isAutoSuggestEnabled: state.ContactState.AutoSuggestState.isAutoSuggestEnabled,
    isAutoSuggestV2Enabled: state.ContactState.AutoSuggestState.isAutoSuggestV2Enabled,
    isAnyAutoSuggestEnabled:
      state.ContactState.AutoSuggestState.isAutoSuggestEnabled ||
      state.ContactState.AutoSuggestState.isAutoSuggestV2Enabled,
    suggestions: getSuggestionsSelector(state),
    market: state.GlobalState.market,
    isAutoSuggestHidden: state.ContactState.AutoSuggestState.isAutoSuggestHidden,
    isAutoSuggestQuery: state.ContactState.AutoSuggestState.isAutoSuggestQuery,
    isDeepLinkQuery: state.ContactState.SharedState.isDeepLinkQuery,
    isDeepLinkEnabled: state.ContactState.SharedState.isDeepLinkEnabled,
    isCreatingRequest: state.ContactState.ModalitySectionState.isCreatingRequest,
    alchemyThemeRoutingEnabled: state.ContactState.ModalitySectionState.alchemyThemeRoutingEnabled,
    originalQuery: state.ContactState.AutoSuggestState.originalQuery,
    showSearchBar: showSearchBarSelector(state),
    isThirdParty: isThirdPartySelector(state),
    isTeams: isTeamsSelector(state),
    isSurfaceApp: isSurfaceAppSelector(state),
    isGetHelp: isGetHelpSelector(state),
    isDarkTheme: isDarkThemeSelector(state),
    isGetHelpBtnHidden: isGetHelpBtnHiddenSelector(state),
    isPrivacyAndSupportHidden: isPrivacyAndSupportHiddenSelector(state),
    deeplinkPath: deeplinkPathSelector(state),
    shouldProceedQueryForGetHelp: shouldProceedQueryForGetHelpSelector(state),
    isQueryChanged: isQueryChangedSelector(state),
    isFeedbackCoachmarkEnabled: isFeedbackCoachmarkEnabledSelector(state),
    isFeedbackCoachmarkShowing: isFeedbackCoachmarkShowingSelector(state),
  };
};

export const FormQuerySubmitContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(FormQuerySubmit, getContactUsStyles));
